import React from 'react';
import isEmpty from 'lodash/isEmpty';

const FormField = ({children, error}) => {
    let errMessage;
    if (!isEmpty(error)) {
        if (Array.isArray(error)) {
            errMessage = error[error.length - 1]
        } else {
            errMessage = error
        }
    }
    return (
        <div className={errMessage ? 'error' : ''}>
            {children}
            {errMessage && <p>{errMessage}</p>}
        </div>
    )
};

export default FormField;


// WEBPACK FOOTER //
// ./src/components/registration/FormField.js